import React, { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import { Box, Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth } from '../BookingReports/BookingConstants'
import moment from 'moment';
import autoTable from 'jspdf-autotable'
const TopayStatenentReportTable = ({UseToPayAsCOD, tableData, setTableData, reportData,fromDate,toDate,sourceBranch,sourceCity,loginData}) => {
    const [showTable, setShowTable] = useState(true)
    const [state, setState] = useState({
        generatePDF: false,
        load: false,
    })
    const { generatePDF, load } = { ...state }
    let columnHeader = [
        { headerName: 'Challan\nNumber', exportHead: 'Challan\nNo.', field: 'CHALLANNO', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left", showfilter: true },
        { headerName: 'Receiver\nName', exportHead: 'Receiver\nName', field: 'RECEIVERNAME', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "100px", align: "left", showfilter: true },
        { headerName: 'From\nStation', exportHead: 'From\nStation', field: 'FROMSTATION', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left", showfilter: true },
        { headerName: 'Booking\nDate', exportHead: 'Booking\nDate', field: 'INCOMINGDATE', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left", showfilter: true },
        { headerName: 'WayBill\nNumber', exportHead: 'WayBill\nNo.', field: 'WAYBILLNO', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left", showfilter: true },
        { headerName: 'Number of Parcel', exportHead: 'NOP', field: 'NOPS', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right", showfilter: true },
        { headerName: 'Opening\nBalence', exportHead: 'Opening\nBalence', field: 'OPENINGBAL', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right", showfilter: true },
        { headerName: 'ToPay\nAmount', exportHead: 'ToPay\nAMT', field: 'TODAYAMT', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right", showfilter: true },
        { headerName: 'Receive\nAmount', exportHead: 'Receive\nAMT', field: 'RECEIVEAMT', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right", showfilter: true },
        { headerName: 'Receipt\nNumber', exportHead: 'Receipt\nNo.', field: 'RECEIPTNO', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left", showfilter: true },
        { headerName: 'Due\nAmount', exportHead: 'Due\nAMT', field: 'DUEAMT', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right", showfilter: true },
        { headerName: 'Delivery\nDate', exportHead: 'Delivery\nDate', field: 'DeliveryDate', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left", showfilter: true },
    ]
    let columnHeaderUpdated = columnHeader.map((col) => {
        if (UseToPayAsCOD === 1) {
            if (col.field === 'TODAYAMT') {
                return {
                    ...col,
                    headerName: 'COD\nAMT',
                    exportHead: 'COD\nAMT',
                };
            }
        }
        return col;
    });
    const filterData = [
        { headerName: 'From Data', exportHead: 'From Data', field: 'fromDate', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "80px", align: "left" },
        { headerName: 'To Date', exportHead: 'To Date', field: 'toDate', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "100px", align: "left" },
        { headerName: 'City Name', exportHead: 'City Name', field: 'sourceBranch', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "80px", align: "left" },
        { headerName: 'Branch Name', exportHead: 'Branch Name', field: 'sourceCity', xlCol: { dataType: 'string', dataFormatter: null }, minWidth: "100px", align: "left" },
      ]
    const [searchData, setSearchData] = useState({
        CHALLANNO: "",
        RECEIVERNAME: "",
        FROMSTATION: "",
        INCOMINGDATE: "",
        WAYBILLNO: "",
        NOPS: "",
        OPENINGBAL: "",
        TODAYAMT: "",
        RECEIVEAMT: "",
        RECEIPTNO: "",
        DUEAMT: "",
        DeliveryDate: "",
    });
    useEffect(() => {
        const filteredData = reportData?.filter((val) => {
            return (
                (searchData.CHALLANNO === "" || val.CHALLANNO.toLowerCase().includes(searchData.CHALLANNO.toLowerCase())) &&
                (searchData.RECEIVERNAME === "" || val.RECEIVERNAME.toLowerCase().includes(searchData.RECEIVERNAME.toLowerCase())) &&
                (searchData.FROMSTATION === "" || val.FROMSTATION.toLowerCase().includes(searchData.FROMSTATION.toLowerCase())) &&
                (searchData.INCOMINGDATE === "" || val.INCOMINGDATE.toLowerCase().includes(searchData.INCOMINGDATE.toLowerCase())) &&
                (searchData.WAYBILLNO === "" || val.WAYBILLNO.toLowerCase().includes(searchData.WAYBILLNO.toLowerCase())) &&
                (searchData.NOPS === "" || val.NOPS.toString().includes(searchData.NOPS.toString())) &&
                (searchData.OPENINGBAL === "" || val.OPENINGBAL.toString().includes(searchData.OPENINGBAL.toString())) &&
                (searchData.TODAYAMT === "" || val.TODAYAMT.toString().includes(searchData.TODAYAMT.toString())) &&
                (searchData.RECEIVEAMT === "" || val.RECEIVEAMT.toString().includes(searchData.RECEIVEAMT.toString())) &&
                (searchData.RECEIPTNO === "" || val.RECEIPTNO.toLowerCase().includes(searchData.RECEIPTNO.toLowerCase())) &&
                (searchData.DUEAMT === "" || val.DUEAMT.toString().includes(searchData.DUEAMT.toString())) &&
                (searchData.DeliveryDate === "" || val.DeliveryDate.toLowerCase().includes(searchData.DeliveryDate.toLowerCase()))
            );
        });
        setTableData(filteredData);
    }, [searchData, reportData]);
    const handleSearchData = (event, field) => {
        setSearchData({ ...searchData, [field]: event.target.value.toString() });
    };
    const InsideRowContent = ({ item, index, fontVal }) => {
        return (
            <>
                <TableRow>
                    <TableCell
                        className="reportTD"
                        colSpan={1}
                        style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                    >
                        {item.CHALLANNO}
                    </TableCell>
                    <TableCell
                        className="reportTD"
                        colSpan={1}
                        style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                    >
                        {item.RECEIVERNAME}
                    </TableCell>
                    <TableCell
                        className="reportTD"
                        colSpan={1}
                        style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                    >
                        {item.FROMSTATION}
                    </TableCell>
                    <TableCell
                        className="reportTD"
                        colSpan={1}
                        style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                    >
                        {item.INCOMINGDATE}
                    </TableCell>
                    <TableCell
                        className="reportTD"
                        colSpan={1}
                        style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                    >
                        {item.WAYBILLNO}
                    </TableCell>
                    <TableCell
                        className="reportTD"
                        colSpan={1}
                        style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                    >
                        {item.NOPS}
                    </TableCell>
                    <TableCell
                        className="reportTD"
                        colSpan={1}
                        style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                    >
                        {item.OPENINGBAL}
                    </TableCell>
                    <TableCell
                        className="reportTD"
                        colSpan={1}
                        style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                    >
                        {item.TODAYAMT}
                    </TableCell>
                    <TableCell
                        className="reportTD"
                        colSpan={1}
                        style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                    >
                        {item.RECEIVEAMT}
                    </TableCell>
                    <TableCell
                        className="reportTD"
                        colSpan={1}
                        style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                    >
                        {item.RECEIPTNO}
                    </TableCell>
                    <TableCell
                        className="reportTD"
                        colSpan={1}
                        style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                    >
                        {item.DUEAMT}
                    </TableCell>
                    <TableCell
                        className="reportTD"
                        colSpan={1}
                        style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                    >
                        {item.DeliveryDate}
                    </TableCell>
                </TableRow>
            </>
        )
    }
    const printClick = (isSave) => {
        setState({ ...state, load: true, generatePDF: true })
        jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
        jsPDF.API.events.push(["addFonts", callAddFontRobotoMedium]);
        const widthCell = calculateTotalTableWidth(columnHeaderUpdated)
        const HeaderColumns = filterData.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        const pdfColumns = columnHeaderUpdated.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol };
        })
        const HeaderData = [
            {
                fromDate: moment(fromDate).format('DD-MMM-YY'),
                toDate: moment(toDate).format('DD-MMM-YY'),
                sourceBranch: sourceBranch?.BranchName,
                sourceCity: sourceCity?.CityName,
            },
        ]
        const doc = new jsPDF({ orientation: pdfColumns.length > 12 ? 'l' : 'p', format: pdfColumns.length > 12 ? calculateDynamicFormatLandscape((widthCell > 1400 ? widthCell : 1400) + 60) : calculateDynamicFormatPortrait((widthCell > 793 ? widthCell : 793) + 60), unit: 'px', compress: true })
        var pageSize = doc.internal.pageSize
        // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
        var scaleFactor = pageWidth / (pdfColumns.length > 12 ? 1122 : 793);

        var totalPagesExp = '{total_pages_count_string}'
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(scaleFactor * 14)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
        }
        doc.setProperties({
            title: `ToPay Statement Report.pdf`,
            subject: 'ToPay Statement Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Receive',
            creator: 'MTLPL',
        })

        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns,
            body: HeaderData,
            columnStyles: {
                0: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                1: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                2: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                3: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
            },
            theme: 'grid',
            startY: 160,
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: scaleFactor * 14,
                font: 'Roboto',
                fontStyle: 'normal',
                lineWidth: 0.6,
            },
        })

        autoTable(doc, {
            margin: { top: 120, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            headStyles: {
                fillColor: [191, 225, 255],
                fontSize: scaleFactor * 12,
                minCellHeight: 36,
                cellPadding: 6,
                valign: 'middle',
                fontStyle: 'normal',
                font: 'Roboto',
                textColor: [0, 0, 0]
            },
            tableLineWidth: 0.6,
            columns: pdfColumns,
            body: tableData,
            styles: {
                lineWidth: [0, 0.2, 0, 0.2]
            },
            columnStyles: {
                0: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
                1: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 70, halign: 'left', textColor: [0, 0, 0] },
                2: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
                3: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
                4: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
                5: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'right', textColor: [0, 0, 0] },
                6: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'right', textColor: [0, 0, 0] },
                7: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'right', textColor: [0, 0, 0] },
                8: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'right', textColor: [0, 0, 0] },
                9: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
                10: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'right', textColor: [0, 0, 0] },
                11: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
            },
            theme: 'grid',
            didParseCell: (data) => {
                if (data.row.section === 'head') {
                    if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                        data.cell.styles.halign = 'right'
                    } else {
                        data.cell.styles.halign = 'left'
                    }
                }
                // drawCell(data)
            },
            didDrawPage: function (data) {
                doc.setTextColor(scaleFactor * 40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
                doc.setFontSize(scaleFactor * 20).setFont("Roboto", 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System | ToPay Statement Report', 30 + 60, 80)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(scaleFactor * 20).setFont("Roboto", 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            },
        })
        doc.setFont('Roboto')

        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`ToPay Statement Report.pdf`)
            setTimeout(() => {
                setState({ ...state, generatePDF: false, load: true })
                const pdfUrl = doc.output('bloburl')
                document.getElementById('toPayStatementReportOutput').data = pdfUrl
                // document.getElementById('toPayStatementReportOutput').data = doc.output('datauristring', 'ToPayStatementReport..pdf')
                // focusElemnt('backBtn')
            }, 2000)
        } else {
            setTimeout(() => {
                setState({ ...state, generatePDF: false, load: true })
                const pdfUrl = doc.output('bloburl')
                document.getElementById('toPayStatementReportOutput').data = pdfUrl
                // document.getElementById('toPayStatementReportOutput').data = doc.output('datauristring', 'ToPayStatementReport..pdf')
                // focusElemnt('backBtn')
            }, 2000)
        }

    }
    return (
        <>
            <Item className="userReport">
                <Item style={{ padding: '8px 0 0 15px' }} className="userReport-heading">Report For:  To-Pay Statement Report</Item>
                <Item className="userReport-buttons">
                    {showTable ? (
                        <>
                            <Box id={'ExpToExlbtnBox'}>
                                <Item sx={sx.itemsx} className="disabled-wrapper" >
                                    {/* <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, 'PdfBtn', 'generateButton', () => { })}> */}
                                    <ReactHtmlTableToExcel
                                        id="ExpToExlbtn"
                                        className="userWisereporttemExcelBtn"
                                        table="table-to-xls"
                                        filename={`To-Pay Statement Report`}
                                        sheet="tablexls"
                                        buttonText="Export to Excel"
                                    />
                                </Item>
                            </Box>
                            <Box>
                                <Button
                                    variant="outlined"
                                    className="userWisereporttembtn"
                                    onClick={() => { setShowTable(false); printClick(true) }}
                                    // onKeyDown={(e) => navigation3(e, 'PrintBtn', 'ExpToExlbtn', () => { })}
                                    id="PdfBtn"
                                >
                                    Export to Pdf
                                </Button>
                            </Box>
                            <Box>
                                <Button
                                    variant="outlined"
                                    className="userWisereporttembtn"
                                    onClick={() => { setShowTable(false); printClick(false) }}
                                    id="PrintBtn"
                                // onKeyDown={(e) => navigation3(e, 'fromDate', 'PdfBtn', () => { })}
                                >
                                    Print
                                </Button>
                            </Box>
                        </>
                    ) : (
                        <>
                            <Box>
                                <Button
                                    id="backBtn"
                                    variant="outlined"
                                    className="userWisereporttembtn"
                                onClick={() => setShowTable(true)}
                                // onKeyDown={(e) => navigation3(e, '', 'generateButton', () => { setShowTable(true); focusElemnt('generateButton') })}
                                >
                                    Back
                                </Button>
                            </Box>
                        </>
                    )}
                </Item>
            </Item>
            {showTable ? (<>
                <Stack sx={{ marginLeft: 2, marginRight: 2, height: 450, paddingTop: '10px' }}>
                    <TableContainer className="scroll" style={{ border: '1px solid #aeaeae', borderRadius: '6px' }}>
                        <Table id='table-to-xls' className="table1 table-Report" size="small" aria-label="a dense table">
                            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                                <TableRow>
                                    {columnHeaderUpdated?.map((i, index) =>
                                        <TableCell
                                            key={index}
                                            className="ReportItemHead"
                                            style={{
                                                backgroundColor: '#bfe1ff',
                                                color: '#444444',
                                                fontSize: '12px',
                                                lineheight: '16px',
                                                letterspacing: '0.24px',
                                                fontWeight: '500',
                                                textAlign: `${i.align}`,
                                                whiteSpace: 'pre'
                                            }}
                                            colSpan={1}
                                        >
                                            {i.headerName}
                                        </TableCell>
                                    )}
                                </TableRow>
                                <TableRow>
                                    {columnHeaderUpdated.map((col, index) => col.showfilter ?
                                        <TableCell key={`FTH-${index}`} style={{ height: "36px" }}>
                                            <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                                <input
                                                    id={`Contains-${index}`}
                                                    className="field"
                                                    name="cancelSearchInput"
                                                    style={{ width: '100%', height: "24px" }}
                                                    placeholder="Contains"
                                                    autoComplete="off"
                                                    value={searchData[col.field]}
                                                    onChange={(e) => handleSearchData(e, col.field)}
                                                // onKeyDown={(e) => navigation3(e, index === 8 ? `URREditRight-0` : index == 3 ? `Contains-7` : `Contains-${index + 1}`, index === 2 ? "URRSave" : index == 7 ? `Contains-3` : `Contains-${index - 1}`, () => { })}
                                                />
                                                <FilterAltIcon style={{ color: "#aaa" }} />
                                            </div>
                                        </TableCell>
                                        : <TableCell></TableCell>)}
                                </TableRow>
                            </TableHead>
                            {tableData?.length < 1 ? (
                                <>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={12}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        marginTop: '20px',
                                                        marginBottom: '20px',
                                                        color: 'red',
                                                        fontSize: '12px',
                                                        lineheight: '16px',
                                                        letterspacing: '0.24px',
                                                    }}
                                                >
                                                    <span>No results found. Please refine your search parameters and search again.</span>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </>
                            ) : tableData?.length >= 1 ? (
                                <TableBody
                                    className="filter-data-row"
                                    style={{
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        lineheight: '16px',
                                        letterspacing: '0.24px',
                                        fontWeight: '500',
                                        marginLeft: '5px',
                                    }}
                                >
                                    {tableData?.map((item, index) => (
                                        <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                                    ))}
                                </TableBody>
                            ) : (
                                ''
                            )}
                        </Table>
                    </TableContainer>
                </Stack>
            </>
            ) : (
                <>
                    {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
                    {load ? (
                        <object
                            id="toPayStatementReportOutput"
                            type="application/pdf"
                            width={'100%'}
                            height="440"
                            title="MTLPL -Cargo System - After Transfer Summary Report"
                            aria-label="MTLPL -Cargo System - After Transfer Summary Report"
                        ></object>
                    ) : (
                        ''
                    )}
                </>
            )}

        </>
    )
}

export default TopayStatenentReportTable